<nav class="rail-navigation__list" aria-label="Profile">
  @let states = currentStates();
  @for (railElement of railNavigationService.elements(); track railElement) {
    @let current = states.get(railElement) ?? null;
    <a class="rail-navigation-link"
      [ngClass]="{ 'rail-navigation-link--single-line': railElement.singleLine }"
      #link
      [routerLink]="railElement.disabled ? null : railElement.link"
      [class.rail-navigation-link--active]="current !== null"
      [class.rail-navigation-link--disabled]="railElement.disabled"
      [attr.aria-disabled]="railElement.disabled ? 'true' : null"
      [attr.aria-current]="current">
      <span class="rail-navigation-link__indicator mat-focus-indicator"
        matRipple
        [matRippleTrigger]="link"
        aria-hidden="true"></span>
      <span class="rail-navigation-link__top-row">
        <span class="rail-navigation-link__icon-wrapper">
          <mat-icon
            class="rail-navigation-link__icon">
            {{ railElement.icon }}
          </mat-icon>
        </span>
      </span>
      <span class="rail-navigation-link__label">
        {{ railElement.text }}
      </span>
    </a>
  }
</nav>
